import React from "react";
import * as FiIcons from "react-icons/fi";
import SafeIcon from "../../../common/SafeIcon";

const { FiGlobe, FiMail } = FiIcons;

export default function ClientAccountantContactCard({
  team,
  firm,
  clientProfile,
}) {
  const emails = [...new Set(
    (team || []).map((member) => member.email).filter(Boolean)
  )];
  const clientEmail = clientProfile?.business_email;

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <h2 className="text-base font-bold text-slate-900">
        Contact Your Accountant
      </h2>
      <p className="mt-1 text-sm text-slate-500">
        Use the available contact details for your accounting relationship.
      </p>

      {emails.length || clientEmail || firm?.website ? (
        <div className="mt-5 flex flex-wrap gap-3">
          {emails.map((email) => (
            <a
              key={email}
              href={`mailto:${email}`}
              className="inline-flex items-center gap-2 rounded-xl bg-violet-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-violet-700"
            >
              <SafeIcon icon={FiMail} />
              Email {emails.length > 1 ? email : "accountant"}
            </a>
          ))}
          {!emails.length && clientEmail && (
            <a
              href={`mailto:${clientEmail}`}
              className="inline-flex items-center gap-2 rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
            >
              <SafeIcon icon={FiMail} />
              Email your business
            </a>
          )}
          {firm?.website && (
            <a
              href={
                firm.website.startsWith("http")
                  ? firm.website
                  : `https://${firm.website}`
              }
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
            >
              <SafeIcon icon={FiGlobe} />
              Visit firm website
            </a>
          )}
        </div>
      ) : (
        <p className="mt-5 rounded-xl bg-slate-50 p-4 text-sm text-slate-600">
          Contact information is not available yet.
        </p>
      )}
    </section>
  );
}